import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14b8a362"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "array-holder" }
const _hoisted_2 = { class: "flex items-center q-px-xs" }
const _hoisted_3 = { class: "label-block" }
const _hoisted_4 = {
  key: 0,
  class: "block text-red errors-label"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Add")
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_dispatch_renderer = _resolveComponent("dispatch-renderer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.arraySchema?.title || _ctx.control.uischema.label || _ctx.control.label) + " ", 1),
        (_ctx.control.errors)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.control.errors), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_q_btn, {
        icon: "add",
        small: "",
        rounded: "",
        flat: "",
        ripple: false,
        class: "q-ml-auto btn--no-hover",
        disabled: 
          !_ctx.control.enabled ||
          (_ctx.appliedOptions.restrict &&
            _ctx.arraySchema !== undefined &&
            _ctx.arraySchema.maxItems !== undefined &&
            _ctx.dataLength >= _ctx.arraySchema.maxItems)
        ,
        onClick: _ctx.addButtonClick
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tooltip, null, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    (_ctx.dataLength != 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.control.data, (element, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "row no-wrap full-width q-mb-xs",
              key: `${_ctx.control.path}-${index}`
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getValidColumnProps(_ctx.control.schema), (propName) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col q-mb-md",
                  key: _ctx.composePaths(_ctx.composePaths(_ctx.control.path, `${index}`), propName)
                }, [
                  _createVNode(_component_dispatch_renderer, {
                    schema: _ctx.control.schema,
                    uischema: _ctx.resolveUiSchema(propName),
                    path: _ctx.composePaths(_ctx.control.path, `${index}`),
                    enabled: _ctx.control.enabled,
                    renderers: _ctx.control.renderers,
                    cells: _ctx.control.cells,
                    "item-label": _ctx.control.uischema?.options?.itemLabel || ''
                  }, null, 8, ["schema", "uischema", "path", "enabled", "renderers", "cells", "item-label"])
                ]))
              }), 128)),
              (_ctx.control.enabled)
                ? (_openBlock(), _createElementBlock("td", {
                    key: 0,
                    class: _normalizeClass(_ctx.appliedOptions.showSortButtons ? 'fixed-cell' : 'fixed-cell-small')
                  }, [
                    _createVNode(_component_q_btn, {
                      rounded: "",
                      flat: "",
                      small: "",
                      icon: "delete",
                      class: _normalizeClass(["btn--no-hover", _ctx.styles.arrayList.itemDelete]),
                      disabled: 
              !_ctx.control.enabled ||
              (_ctx.appliedOptions.restrict &&
                _ctx.arraySchema !== undefined &&
                _ctx.arraySchema.minItems !== undefined &&
                _ctx.dataLength <= _ctx.arraySchema.minItems)
            ,
                      onClick: ($event: any) => (_ctx.removeItemsClick($event, [index]))
                    }, null, 8, ["class", "disabled", "onClick"])
                  ], 2))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}